import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-database",
  "use": "icon-si-glyph-database-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-database\" id=\"icon-si-glyph-database\"><title>645</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 0.000000)\" fill=\"#434343\"><ellipse cx=\"6.43\" cy=\"2.421\" rx=\"6.43\" ry=\"2.421\" class=\"si-glyph-fill\" /><path d=\"M6.463,11.08 C2.947,11.08 0.016,10.1 0.016,9.444 L0.016,12.713 C0.016,13.901 2.903,14.859 6.463,14.859 C10.023,14.859 12.91,13.9 12.91,12.713 L12.91,9.444 C12.91,10.1 9.979,11.08 6.463,11.08 L6.463,11.08 Z\" class=\"si-glyph-fill\" /><path d=\"M6.494,6.051 C2.978,6.051 0.047,5.049 0.047,4.377 L0.047,7.723 C0.047,8.937 2.934,9.919 6.494,9.919 C10.054,9.919 12.941,8.937 12.941,7.723 L12.941,4.377 C12.941,5.049 10.01,6.051 6.494,6.051 L6.494,6.051 Z\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-database.svg
// module id = 26cM
// module chunks = 62